import { API } from "actions/api";
import NotificationManager from "utils/notifications";

const GENERIC_ERROR = "Something went wrong. Please try again.";

// S3DEV2-7710: mfa/send-code and mfa/resend-code require the pending token that
// sign_in returns (user_details.mfa_pending_token) in this header. Passing any
// headers replaces the middleware default, so Content-Type must be set here too
// or the JSON email body is rejected with a 415.
const pendingTokenHeaders = pendingToken => ({
  "Content-Type": "application/json",
  ...(pendingToken ? { "X-MFA-Pending-Token": pendingToken } : {})
});

export const setMFAOptions = body => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: "patient_portal/mobile/mfa",
      method: "PUT",
      body
    });
    return result;
  } catch (error) {
    console.error("setMFAOptions:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const fetchMFAOptions = () => async dispatch => {
  try {
    const MFAOptions = await dispatch({
      type: API,
      route: "patient_portal/mobile/mfa",
      method: "GET"
    });
    return MFAOptions;
  } catch (error) {
    console.error("fetchMFAOptions:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const verifyPhoneNumber = body => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: "patient_portal/mobile/mfa/phone-verify",
      method: "PUT",
      body
    });
    return result;
  } catch (error) {
    console.error("verifyPhoneNumber:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const sendCodeToContactMethod = (means, body, pendingToken) => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: `patient_portal/mobile/mfa/send-code/${means}`,
      method: "POST",
      body,
      headers: pendingTokenHeaders(pendingToken)
    });
    return result;
  } catch (error) {
    console.error("sendCodeToContactMethod:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const updateMFAPhone = body => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: "patient_portal/mobile/mfa/phone",
      method: "PUT",
      body
    });
    return result;
  } catch (error) {
    console.error("updateMFAPhone:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};

export const resendCodeToContactMethod = (means, body, pendingToken) => async dispatch => {
  try {
    const result = await dispatch({
      type: API,
      route: `patient_portal/mobile/mfa/resend-code/${means}`,
      method: "POST",
      body,
      headers: pendingTokenHeaders(pendingToken)
    });
    return result;
  } catch (error) {
    console.error("resendCodeToContactMethod:", error.message);
    NotificationManager.error(GENERIC_ERROR);
  }
};
